import { makeStyles } from '@fluentui/react-components';

export const useCSATTrendChartStyles = makeStyles({
  root: {
    width: '100%',
  },
});
